import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Main";
import Login from "./Login/Login";
import DashboardPage from "./pages/dashboard/DashboardPage";
import AcademicDashboard from "./pages/academics/AcademicDashboard";
import TransportDashboard from "./pages/transport/TransportDashboard";
import HumanResourcesDashboard from "./pages/hr/HrDashboard";
import PerumbakkamDashboard from "./pages/schoolbranches/Perumbakkam";
import Hyderabad from "./pages/schoolbranches/Hyderabad";
import Thiruvanmiyur from "./pages/schoolbranches/Thiruvanmiyur";
import Kvr from "./pages/schoolbranches/Kvr";
import Thirumudivakkam from "./pages/schoolbranches/Thirumudivakkam";
import BestSchool from "./pages/BestSchool";
import EditSheet from "./pages/EditSheet";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <Main>
              <DashboardPage />
            </Main>
          }
        />
        <Route
          path="/academics"
          element={
            <Main>
              <AcademicDashboard />
            </Main>
          }
        />
         <Route
          path="/branches/perumbakkam"
          element={
            <Main>
              <PerumbakkamDashboard />
            </Main>
          }
        />
        <Route
          path="/branches/kvr-campus"
          element={
            <Main>
              <Kvr />
            </Main>
          }
        />
         <Route
          path="/branches/thiruvanmiyur"
          element={
            <Main>
              <Thiruvanmiyur />
            </Main>
          }
        />
         <Route
          path="/branches/thirumudivakkam"
          element={
            <Main>
              <Thirumudivakkam />
            </Main>
          }
        />
         <Route
          path="/branches/hyderabad"
          element={
            <Main>
              <Hyderabad />
            </Main>
          }
        />
        <Route
          path="/transport"
          element={
            <Main>
              <TransportDashboard />
            </Main>
          }
        />
         <Route
          path="/hr"
          element={
            <Main>
              <HumanResourcesDashboard />
            </Main>
          }
        />
         <Route
          path="/best-school"
          element={
            <Main>
              <BestSchool />
            </Main>
          }
        />
       
        <Route
          path="/edit/:tabKey"
          element={
            <Main>
              <EditSheet />
            </Main>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
